const tolerance = 0.000001;

// Display alias only: API/DB ReceivingStatus remains "Cancelled".
// Closure continues to use /api/T_PO_Header/cancel/{id} and its existing audit log.
export const PO_CLOSURE_NOTE = 'The unreceived balance is closed. Existing Goods Receipts and inventory are retained. Further receiving is blocked.';

export function getPoReceivingStatusLabel(status) {
  return String(status ?? '').trim().toLowerCase() === 'cancelled' ? 'Closed PO' : status;
}

export function getPoReceivingStatusNote(status) {
  return getPoReceivingStatusLabel(status) === 'Closed PO' ? PO_CLOSURE_NOTE : undefined;
}

export function getPoReceivingStatus(details) {
  const lines = (Array.isArray(details) ? details : []).map(line => {
    const ordered = Number(line.qty ?? line.orderedQty ?? 0);
    const baseOrdered = Number(line.baseQty ?? 0);
    const snapshotFactor = Number(line.uomConversionFactor ?? 0);
    const factor = snapshotFactor > 0 ? snapshotFactor
      : baseOrdered > 0 && ordered > 0 ? baseOrdered / ordered : 1;
    const received = Math.max(0, Number(line.totalReceivedQty ?? 0),
      Number(line.totalReceivedBaseQty ?? 0) / factor);
    return { ordered, received };
  });

  if (!lines.some(line => line.received > tolerance)) return 'Pending';
  const orderedLines = lines.filter(line => line.ordered > tolerance);
  return orderedLines.length > 0 && orderedLines.every(line => line.received + tolerance >= line.ordered)
    ? 'Complete' : 'Partial';
}
